import { memo } from "react";
import { Link } from "react-router-dom";
import { useSidebar, SidebarTrigger } from "@/components/ui/sidebar";
import { UserAvatar } from "@/components/user/UserAvatar";

export const SidebarUserSection = memo(() => {
  const { state } = useSidebar();

  return (
    <div className="flex flex-col gap-3 border-b border-sidebar-border/30">
      {state === "collapsed" ? (
        <div className="relative py-4 w-full">
          <div className="flex justify-center">
            <UserAvatar size="sm" />
          </div>
          <SidebarTrigger className="absolute top-1/2 -translate-y-1/2 right-0 translate-x-1/2 w-5 h-5 flex items-center justify-center z-10" />
        </div>
      ) : (
        <div className="flex items-center justify-between p-4">
          <Link to="/" className="flex items-center">
            <div className="sidebar-icon-container">
              <UserAvatar />
              <span className="text-xl font-black text-foreground ml-2 tracking-tight">
                Farmvault
              </span>
            </div>
          </Link>
          <SidebarTrigger />
        </div>
      )}
    </div>
  );
});

SidebarUserSection.displayName = 'SidebarUserSection';